<template>
    <center>
      <div class="card card-body agatrs-card-style">
        <Header
          pageTitle="FMR-14R: Liabilities Report"
        ></Header>
        <div class="row justify-contnet-center">
          <div class="col-md-12 subtitle">
            {{ subtitle }}
          </div>
          <br/>
          <div class="col-md-12 subtitle">
            Please select a COCOM or Country and Fiscal Year to generate a report.
          </div>
          <br/>
          <br/>

        </div>
        <br/>
        <div class="row justify-content-center">
          <!-- <div class="col-md-12 subtitle2">
            Please select a COCOM or Country and Fiscal Year to generate a report.
          </div>
          <br/>
          <br/> -->
          <div class="col-md-1 align-left">
            <label>COCOM AOR:</label>
          </div>
          <div class="col-md-3">
            <v-select
              v-model="selectedAorId"
              name="AorsDropdown"
              :reduce="(item) => item.areaOfResponsibilityId"
              label="name"
              :options="[{areaOfResponsibilityId: undefined, name: 'All'}].concat(aors)"
              placeholder="Select"
              :error="getError('AorsDropdown')"
            ></v-select>
          </div>
  
          <div class="col-md-1 align-left">
            <label>Country:</label>
          </div>
          <div class="col-md-3">
            <v-select
              v-model="countryId"
              name="PartnerNationDropdown"
              v-bind:disabled="isCountriesDisabled"
              :reduce="(item) => item.countryId"
              label="name"
              :options="countries"
              placeholder="Select"
              :error="getError('PartnerNationDropdown')"
            ></v-select>
          </div>
  
          <div class="col-md-1 align-left">
            <label>Fiscal Year:</label>
          </div>
          <div class="col-md-3">
            <base-input>
              <v-select
                v-model="year"
                name="FiscalYear"
                :reduce="(item) => item.year"
                label="label"
                :options="fiscalYears"
                placeholder="Select"
              ></v-select>
            </base-input>
          </div>
        </div>
        <br />
        <div class="row justify-content-center">
          <div class="col-md-2 col-sm-12">
            <base-button
              class="btn btn-danger"
              @click="initializeAllData()"
              v-b-popover.hover.top="'Reset all fields!'"
            >
              <i class="tim-icons icon-alert-circle-exc"></i> Clear
            </base-button>
          </div>
  
          <div class="col-md-2 col-sm-12">
            <!-- justify-content-md-center justify-content-end -->
            <base-button
              @click="getData()"
              type="primary"
              v-b-popover.hover.bottom="'Generate Report!'"
            >
              <i class="tim-icons icon-atom"></i> Generate
            </base-button>
          </div>
          <div></div>
        </div>
      </div>
  
      <br />
  
      <!--  <div class="card card-body agatrs-card-style" v-if="aors?.length <= 0">
        <div class="card-container">
          <div class="title">
            <h4>No Results</h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-12">
            <br />
            <div style="padding: 20px 40px">
              No data was found for the selected criteria
            </div>
          </div>
        </div>
      </div>-->
  
      <div class="card card-body agatrs-card-style" v-if="html !== ''">
        <div class="card-container" >
          <div class="print" style="margin-bottom: 5px">
            <base-button @click="print" class="btn-dark">PRINT</base-button>
          </div>
        </div>
          <div class="row justify-content-center">
            <div class="col-md-12">
              <br />
              <div style="padding: 20px 40px">
                <div id="report" v-html="html"></div>
              </div>
            </div>
          </div>
      </div>
    </center>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import axios from "@/axios";
  import Header from "@/components/App/Header.vue";
  import Utility from "@/mixins/utility/utility";
  import Util from "@/util/util";
  
  export default {
    name: "CreditReports",
    mixins: [Utility],
    components: {
      Header,
    },
    data() {
      return {
        aors: [],
        countryId: undefined,
        year: undefined,
        html: "",
        selectedBuyOrSell: undefined,
        selectedAorId: undefined,
        subtitle: "The Liabilities Report describes debts owed to NATO or Non-NATO countries by the United States. The report filters by support type, country, and order number for total USD delivered, undelivered, and outstanding. It is broken out by Country Total for the COCOM AOR, Country Total per Type of Support, and Country Total by Requisition Number. This report is outlined in the Financial Management Regulation (FMR)."
      };
    },
    async mounted() {
      this.$loaderApp.addRequest();
      await this.getAllCountries();
      await this.getFiscalYears();
      await this.getAors();
      this.selectedBuyOrSell = this.$route.meta.buyOrSell;
      this.$loaderApp.completeRequest();
    },
    computed: {
      ...mapGetters({
        countries: "countries/allCountries",
        fiscalYears: "fiscalYears/fiscalYears",
      }),
      isCountriesDisabled() {
        return this.selectedAorId > 0 ? true : false;
      },
    },
    watch: {
       selectedAorId(value) {
       let result = this.selectedAorId > 0 ? true : false;
  
       if(!result) return;
       
       this.countryId = undefined;
      },
    },
    methods: {
      ...mapActions({
        getAllCountries: "countries/getAllCountries",
        getFiscalYears: "fiscalYears/getFiscalYears",
      }),
      async initializeAllData() {
        Object.assign(this.$data, this.$options.data());
        this.selectedBuyOrSell = this.$route.meta.buyOrSell;
        await this.getAors();
      },
      async getData() {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            var ctx = this;
            this.$loaderApp.addRequest();
            try {
              var response = await axios({
                url: "/api/fmrs/creditliabilityreport/html",
                method: "POST",
                data: {
                  countryId: ctx.countryId,
                  fiscalYear: ctx.year,
                  buyOrSell: ctx.selectedBuyOrSell,
                  AreaOfResponsibilityId: ctx.selectedAorId,
                },
                config: { showToast: false },
              });
              ctx.$loaderApp.completeRequest();
              ctx.html = response.data;
            } catch(error) {
                ctx.$loaderApp.completeRequest();
                this.$toast.error(error.response.data.message);
            }
          }
        });
      },
      print() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let ctx = this;
            this.$loaderApp.addRequest();
            axios({
              url: "/api/fmrs/creditliabilityreport/pdf",
              method: "POST",
              data: {
               countryId: ctx.countryId,
                fiscalYear: ctx.year,
                buyOrSell: ctx.selectedBuyOrSell,
                AreaOfResponsibilityId: ctx.selectedAorId,
              },
              config: { showToast: false },
              responseType: "blob", // important
            }).then((response) => { Util.fileDownload(response.data, "Liability Report.pdf"); 
                ctx.$loaderApp.completeRequest();
            }).catch(error => {
                this.$toast.error(error);
                ctx.$loaderApp.completeRequest();
            });
          }
        });
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      async getAors() {
          const response =  await this.axios.get("/api/aors");
          this.aors = response.data;
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .card-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 0px;
    max-width: 100%;
    min-width: 400px;
    .print {
      margin: auto;
      margin-left: 0px;
      padding: 0px;
      flex-grow: 1;
      text-align: left;
    }
    .title {
      margin: auto;
      margin-left: 0px;
      padding: 0px;
      text-align: center;
      flex-grow: 1;
      text-align: left;
      align-items: center;
      .title > h2 {
        text-align: left !important;
      }
    }
    .disabled {
      pointer-events: none;
      color: #bfcbd9;
      cursor: not-allowed;
      background-image: none;
      background-color: #eef1f6;
      border-color: #d1dbe5;
    }
  }
  .subtitle {
    padding-left: 15% !important;
    padding-right: 15% !important;
    padding-bottom: 30px !important;
  }
  .subtitle2 {
    padding-bottom: 30px !important;
  }
  </style>
  